import { transport } from 'config/transport';

export function callApiChangePAsswordUser(username, body) {
    return transport.post(`/trunguong/${username}/changepassword`, body);
}
